<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_530_20057)">
      <path
        d="M3.40061 4.50317L3.34985 16.6064"
        stroke="#AAC2F2"
        stroke-width="2.08396"
        stroke-miterlimit="10"
      />
      <path
        d="M18.9592 20.1789L7.24646 20.1282"
        stroke="#AAC2F2"
        stroke-width="2.08396"
        stroke-miterlimit="10"
      />
      <path
        d="M6.66461 16.6378V13.6159C6.66564 13.3723 6.71461 13.1314 6.80876 12.9068C6.9029 12.6822 7.04038 12.4783 7.21331 12.3068C7.38625 12.1353 7.59126 11.9996 7.81666 11.9073C8.04205 11.8151 8.28341 11.7681 8.52695 11.7692L14.5863 11.7926C14.8299 11.7936 15.0712 11.7467 15.2966 11.6544C15.522 11.5622 15.7271 11.4264 15.9 11.2549C16.0729 11.0835 16.2104 10.8796 16.3045 10.655C16.3987 10.4304 16.4477 10.1894 16.4487 9.94587V7.69702"
        stroke="#AAC2F2"
        stroke-width="2.07876"
        stroke-miterlimit="10"
      />
      <path
        d="M7.31953 13.5311L2.46266 13.5125C1.12363 13.5073 0.033979 14.5887 0.0288374 15.9277L0.0101883 20.7846C0.00504677 22.1236 1.08636 23.2133 2.42539 23.2184L7.28226 23.237C8.62129 23.2422 9.71096 22.1609 9.7161 20.8218L9.73475 15.965C9.7399 14.6259 8.65856 13.5363 7.31953 13.5311Z"
        fill="url(#paint0_linear_530_20057)"
      />
      <path
        d="M4.98094 0.298325L1.72089 0.285807C0.819583 0.282347 0.0861227 1.01021 0.0826618 1.91152L0.0701442 5.17154C0.0666834 6.07286 0.794532 6.80633 1.69584 6.80979L4.95589 6.82231C5.8572 6.82577 6.59066 6.09791 6.59412 5.19659L6.60664 1.93657C6.6101 1.03526 5.88225 0.301786 4.98094 0.298325Z"
        fill="url(#paint1_linear_530_20057)"
      />
      <path
        d="M18.2472 3.46874L14.9872 3.45622C14.0859 3.45276 13.3524 4.18061 13.349 5.08192L13.3364 8.34195C13.333 9.24326 14.0608 9.97672 14.9621 9.98019L18.2222 9.9927C19.1235 9.99616 19.8569 9.26831 19.8604 8.367L19.8729 5.10697C19.8764 4.20566 19.1485 3.4722 18.2472 3.46874Z"
        fill="url(#paint2_linear_530_20057)"
      />
      <path
        d="M21.3156 16.7551L18.0555 16.7426C17.1542 16.7391 16.4208 17.467 16.4173 18.3683L16.4048 21.6283C16.4013 22.5296 17.1292 23.2631 18.0305 23.2666L21.2905 23.2791C22.1919 23.2825 22.9253 22.5547 22.9288 21.6534L22.9413 18.3933C22.9447 17.492 22.2169 16.7586 21.3156 16.7551Z"
        fill="url(#paint3_linear_530_20057)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_530_20057"
        x1="0.330033"
        y1="22.7226"
        x2="8.78275"
        y2="14.6681"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#177AF0" />
        <stop offset="0.99" stop-color="#177AF0" stop-opacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_530_20057"
        x1="3.3285"
        y1="0.468281"
        x2="3.3285"
        y2="6.84785"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A7FF" />
        <stop offset="1" stop-color="#00A7FF" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_530_20057"
        x1="20.109"
        y1="3.69316"
        x2="13.8895"
        y2="9.11616"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A7FF" />
        <stop offset="1" stop-color="#00A7FF" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_530_20057"
        x1="22.8145"
        y1="20.0442"
        x2="16.5755"
        y2="20.0442"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A7FF" />
        <stop offset="1" stop-color="#00A7FF" stop-opacity="0.2" />
      </linearGradient>
      <clipPath id="clip0_530_20057">
        <rect
          width="22.9336"
          height="23"
          fill="white"
          transform="translate(0 0.313965)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'APIGenerationIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
